import { apiClient } from '@/lib/api-client';

export const trainingService = {
    getAll: async () => {
        return apiClient.request('/trainings');
    },

    create: async (data: any) => {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            if (data[key] !== undefined && data[key] !== null) {
                if (key === 'startDate' && data[key] instanceof Date) {
                    formData.append(key, data[key].toISOString());
                } else {
                    formData.append(key, data[key]);
                }
            }
        });

        return apiClient.request('/trainings', {
            method: 'POST',
            body: formData
        });
    },

    update: async (id: string, data: any) => {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            if (data[key] !== undefined && data[key] !== null) {
                if (key === 'startDate' && data[key] instanceof Date) {
                    formData.append(key, data[key].toISOString());
                } else {
                    formData.append(key, data[key]);
                }
            }
        });

        return apiClient.request(`/trainings/${id}`, {
            method: 'PUT',
            body: formData
        });
    },

    delete: async (id: string) => {
        return apiClient.request(`/trainings/${id}`, {
            method: 'DELETE'
        });
    },

    enroll: async (trainingId: string, data: { organizationName: string; participantCount: number;[key: string]: any }) => {
        return apiClient.request(`/trainings/${trainingId}/enroll`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
    },

    getAllEnrollments: async () => {
        return apiClient.request('/trainings/admin/enrollments');
    },

    updateEnrollmentStatus: async (id: string, status: string) => {
        return apiClient.request(`/trainings/admin/enrollments/${id}`, {
            method: 'PUT',
            body: JSON.stringify({ status })
        });
    }
};
